import { Props_SnippetHero } from './Hero.props'
import SharedHeading from "../Shared/Heading/Heading";
 import SnippetLink from '../Shared/Link/Link';

const SnippetHero = (props: Props_SnippetHero) => {
    const {links, repeatable_links, background} = props;
    // Handle potential undefined props
    const snippet = props?.snippet || {};
    const headingText = snippet.text?.value;
    const alignment = snippet.alignment?.value;
    const visibility = snippet.visibility?.value;
    const level = snippet.level?.value as 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' || 'h1'; // Default to h1 if not provided

    // Calculate visibility - default to true if undefined
    const isVisible = typeof visibility === 'boolean' ? visibility : visibility === 'true' || visibility === undefined;

    // Calculate alignment
    const validAlignment = alignment === "start" || alignment === "center" || alignment === "end" ? alignment : undefined;

      const linkAlignmentClass = links?.alignment?.value
    ? `snippet-media-content__links-container--${links.alignment.value}`
    : '';

    const backgroundClass = background?.background?.value ? `snippet-hero--${background.background.value}` : '';

    return (
        <section className={`snippet-hero ${backgroundClass}`}>
            <img src="/Blob/images/snippets/hero/overlay-top-left.svg" loading="eager" width="55" height="110" alt="" className="snippet-hero__component-overlay snippet-hero__component-overlay--top-left" />
            <img src="/Blob/images/snippets/hero/overlay-top-right.svg" loading="eager" width="122" height="122" alt="" className="snippet-hero__component-overlay snippet-hero__component-overlay--top-right" />
            <img src="/Blob/images/snippets/hero/overlay-top-right-yellow.svg" loading="eager" width="122" height="122" alt="" className="snippet-hero__component-overlay snippet-hero__component-overlay--top-right snippet-hero__component-overlay--top-right-yellow" />
            <img src="/Blob/images/snippets/hero/overlay-bottom-right.svg" loading="eager" width="53" height="53" alt="" className="snippet-hero__component-overlay snippet-hero__component-overlay--bottom-right" />
            <SharedHeading
                level={level}
                className="snippet-hero__heading"
                alignment={validAlignment}
                visibility={isVisible}
            >
                {headingText}
            </SharedHeading>

            <div className={`snippet-hero__links-container ${linkAlignmentClass}`}>
                {repeatable_links?.map((link, index) => (
                    link.linkText?.value && link.linkHref?.value && (
                    <SnippetLink
                        key={index}
                        className="snippet-hero__link attrax-button"
                        url={link.linkHref.value}
                        openInNewTab={typeof link.linkTarget?.value === 'boolean' ? link.linkTarget.value : link.linkTarget?.value === 'true'}
                        linkStyles={link.linkStyle?.value}
                    >
                        {link.linkText.value}
                    </SnippetLink>
                    )
            ))}
          </div>

        </section>
    );
}

export default SnippetHero
